import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';

import {
  updateCompany,
  getCompanyDetails,
  createOrUpdateCompanyRole,
  deleteCompanyRole,
} from 'actions/companyDetailsActions';

import ColorUploaderForm from './ColorUploaderForm';
import CompanyAddressForm from './CompanyAddressForm';
import LogoUploaderForm from './LogoUploaderForm';
import CompanySocialMediaForm from './CompanySocialMediaForm';
import CompanyLandlordWebSolutionsForm from './CompanyLandlordWebSolutionsForm';
import MenuHeader from 'components/shared/MenuHeader';
import CompanyRoles from 'navigation/CompanyRoles';

import { deepDiver } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

export default connect(
  store => ({
    userType: store.userTypes.loginAuth,
    passwordRedirectURL: store.userTypes.passwordRedirectURL,
    company: store.companyDetails.company,
  }),
  { updateCompany, getCompanyDetails, createOrUpdateCompanyRole, deleteCompanyRole }
)(
  class CompanyProfile extends Component {
    constructor(props) {
      super(props);
      this.state = {
        option1Open: false,
        option2Open: false,
        optionHeroImageOpen: false,
        optionSocialMediaOpen: false,
        optionRolesOpen: false,
        colorOptionOpen: false,
        leadCaptureOptionOpen: false,
      };
    }

    UNSAFE_componentWillMount = () => {
      this.props.getCompanyDetails();
    };

    handleSubmit = formData => {
      return this.props.updateCompany(formData);
    };

    render() {
      let existing_logo;
      if (this.props.company) {
        existing_logo = this.props.company.logo_url;
      }

      let existing_hero_image;
      if (this.props.company) {
        existing_hero_image = this.props.company.hero_image_url;
      }

      const companyAccentColor = this.props.company ? this.props.company.accent_color : '#ff3434';

      const companyLeadCaptureLink = this.props.company
        ? this.props.company.lead_capture_link
        : 'N/A';

      const companyLogoDescription = (
        <Fragment>
          {getTranslatedString('landLordPortal.companyProfile.companyLogo.pleaseProvide')}
          <br />
          <br />
          {getTranslatedString('landLordPortal.companyProfile.companyLogo.additionalInfo')}
        </Fragment>
      );

      const coverDescription = (
        <Fragment>
          {getTranslatedString('landLordPortal.companyProfile.coverImage.pleaseProvide')}
          <br />
          <br />
          {getTranslatedString('landLordPortal.companyProfile.coverImage.additionalInfo')}
        </Fragment>
      );

      return (
        <div className="body" role="main">
          <div className="centers">
            <div style={{ height: '100%', padding: 0 }}>
              <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
                <div style={{ paddingTop: '10px', maxWidth: '720px', margin: '10px auto' }}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <span className="page-title">
                      {getTranslatedString(
                        'landLordPortal.companyProfile.header.companyProfile'
                      )}{' '}
                    </span>
                  </div>
                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companyLogo'
                        )}
                        isOpen={this.state.option2Open}
                      />
                    }
                    onOpening={() => this.setState({ option2Open: true })}
                    onClosing={() => this.setState({ option2Open: false })}
                  >
                    <LogoUploaderForm
                      description={companyLogoDescription}
                      labelText={getTranslatedString(
                        'landLordPortal.companyProfile.menuFormLabel.logo'
                      )}
                      formName="landlord_logo_form"
                      name="new_logo.file"
                      onSubmit={this.handleSubmit}
                      required
                      initialValues={{ new_logo: { file: existing_logo } }}
                      fileValidation="image/jpeg, image/png, image/jpg"
                    />
                  </Collapsible>
                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.coverImage'
                        )}
                        isOpen={this.state.optionHeroImageOpen}
                      />
                    }
                    onOpening={() => this.setState({ optionHeroImageOpen: true })}
                    onClosing={() => this.setState({ optionHeroImageOpen: false })}
                  >
                    <LogoUploaderForm
                      description={coverDescription}
                      labelText={getTranslatedString(
                        'landLordPortal.companyProfile.menuFormLabel.coverImage'
                      )}
                      formName="hero_image_form"
                      name="new_hero_image.file"
                      required={false}
                      onSubmit={this.handleSubmit}
                      initialValues={{ new_hero_image: { file: existing_hero_image } }}
                    />
                  </Collapsible>
                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companyAccentColor'
                        )}
                        isOpen={this.state.colorOptionOpen}
                      />
                    }
                    onOpening={() => this.setState({ colorOptionOpen: true })}
                    onClosing={() => this.setState({ colorOptionOpen: false })}
                  >
                    <ColorUploaderForm
                      onSubmit={this.handleSubmit}
                      initialValues={this.props.company}
                      selectedColor={companyAccentColor}
                    />
                  </Collapsible>

                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companyAddress'
                        )}
                        isOpen={this.state.option1Open}
                      />
                    }
                    onOpening={() => this.setState({ option1Open: true })}
                    onClosing={() => this.setState({ option1Open: false })}
                  >
                    <CompanyAddressForm
                      form="company_address"
                      onSubmit={this.handleSubmit.bind(this)}
                      initialValues={this.props.company}
                    />
                  </Collapsible>

                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companySocialMedia'
                        )}
                        isOpen={this.state.optionSocialMediaOpen}
                      />
                    }
                    onOpening={() => this.setState({ optionSocialMediaOpen: true })}
                    onClosing={() => this.setState({ optionSocialMediaOpen: false })}
                  >
                    <CompanySocialMediaForm
                      onSubmit={this.handleSubmit}
                      initialValues={this.props.company}
                    />
                  </Collapsible>

                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companyLeadLink'
                        )}
                        isOpen={this.state.leadCaptureOptionOpen}
                      />
                    }
                    onOpening={() => this.setState({ leadCaptureOptionOpen: true })}
                    onClosing={() => this.setState({ leadCaptureOptionOpen: false })}
                  >
                    <div
                      style={{
                        textAlign: 'center',
                        margin: '15px',
                        padding: '25px',
                        border: `1px dashed ${colors.GRAY}`,
                        position: 'relative',
                        background: 'rgb(253, 253, 253)',
                        minHeight: '92px',
                      }}
                    >
                      <p
                        style={{
                          textAlign: 'center',
                          fontSize: '1.6em',
                          lineHeight: '2',
                          margin: '0',
                          textColor: '#242424',
                        }}
                      >
                        {companyLeadCaptureLink}
                      </p>
                    </div>
                  </Collapsible>

                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.companyRoles'
                        )}
                        isOpen={this.state.optionRolesOpen}
                      />
                    }
                    onOpening={() => this.setState({ optionRolesOpen: true })}
                    onClosing={() => this.setState({ optionRolesOpen: false })}
                  >
                    <CompanyRoles
                      createOrUpdateCompanyRole={this.props.createOrUpdateCompanyRole}
                      deleteCompanyRole={this.props.deleteCompanyRole}
                      roles={deepDiver(this.props, 'company.roles') || []}
                    />
                  </Collapsible>

                  <Collapsible
                    trigger={
                      <MenuHeader
                        menuTitle={getTranslatedString(
                          'landLordPortal.companyProfile.menuTitle.landlordWebSolutions'
                        )}
                        isOpen={this.state.optionRolesOpen}
                      />
                    }
                    onOpening={() => this.setState({ optionRolesOpen: true })}
                    onClosing={() => this.setState({ optionRolesOpen: false })}
                  >
                    <CompanyLandlordWebSolutionsForm
                      onSubmit={this.handleSubmit}
                      initialValues={this.props.company}
                    />
                  </Collapsible>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
